export interface PlataformaDoLink { id: string; nome: string; }

/** Ordem importa: "cardapio.ai" está dentro de "meucardapio.ai", e "ifood" pode aparecer no caminho de outros links. */
const PLATAFORMAS: {id: string; nome: string; trechos: string[]}[] = [
  {id: 'olaclick', nome: 'OlaClick', trechos: ['.ola.click', 'olaclick']},
  {id: 'anotaai', nome: 'Anota AI', trechos: ['anota.ai', 'anotaai']},
  {id: 'meucardapio', nome: 'MeuCardápio', trechos: ['meucardapio.ai', 'promokit.com.br']},
  {id: 'cardapioai', nome: 'Cardapio.ai', trechos: ['cardapio.ai']},
  {id: 'goomer', nome: 'Goomer', trechos: ['goomer']},
  {id: 'cardapioweb', nome: 'Cardápio Web', trechos: ['cardapioweb']},
  {id: 'uairango', nome: 'UaiRango', trechos: ['uairango']},
  {id: 'aiqfome', nome: 'aiqfome', trechos: ['aiqfome']},
  {id: 'instadelivery', nome: 'InstaDelivery', trechos: ['instadelivery']},
  {id: 'menudino', nome: 'MenuDino', trechos: ['menudino']},
  {id: 'deliverydireto', nome: 'Delivery Direto', trechos: ['deliverydireto']},
  {id: 'takeat', nome: 'Takeat', trechos: ['takeat']},
  {id: 'pecaqui', nome: 'Pecaqui', trechos: ['pecaqui.online']},
  {id: 'pedirdelivery', nome: 'Pedir Delivery', trechos: ['pedir.delivery']},
  {id: 'livemenu', nome: 'Live Menu', trechos: ['livemenu.app']},
  {id: 'yooga', nome: 'Yooga', trechos: ['yooga']},
  {id: 'whatsmenu', nome: 'WhatsMenu', trechos: ['whatsmenu']},
  {id: 'brendi', nome: 'Brendi', trechos: ['brendi']},
  {id: 'ifood', nome: 'iFood', trechos: ['ifood']}
];

export const NOMES_DAS_PLATAFORMAS = ['iFood', 'Anota AI', 'Goomer', 'aiqfome', 'Cardápio Web', 'OlaClick', 'e outras'];

/** "Tenho outro sistema": as plataformas que o link reconhece além do iFood (e do próprio MeuCardápio). */
export const OUTRAS_PLATAFORMAS = PLATAFORMAS.filter(p => p.id !== 'ifood' && p.id !== 'meucardapio').map(p => p.nome);

export function detectePlataforma(link: string): PlataformaDoLink | null {
  const texto = String(link || '').toLowerCase().trim();
  if (!texto) return null;
  const achada = PLATAFORMAS.find(p => p.trechos.some(t => texto.includes(t)));
  return achada ? {id: achada.id, nome: achada.nome} : null;
}

/** Mesmo preenchimento do assistente: o que faltar no produto da plataforma vira vazio, nunca undefined. */
export function montePayload(produto: any): any {
  const payload = {...produto};
  payload.descricao = payload.descricao || '';
  if (typeof payload.categoria === 'string') payload.categoria = {nome: payload.categoria};
  if (!payload.categoria && payload.nomeCategoria) payload.categoria = {nome: payload.nomeCategoria};
  payload.categoriasAcima = Array.isArray(payload.categoriasAcima) ? payload.categoriasAcima : [];
  payload.camposAdicionais = Array.isArray(payload.camposAdicionais) ? payload.camposAdicionais : (payload.adicionais || []);
  payload.disponibilidades = Array.isArray(payload.disponibilidades) ? payload.disponibilidades : [];
  if (!payload.urlImagemExterna && (payload.imagem || payload.linkImagem)) payload.urlImagemExterna = payload.imagem || payload.linkImagem;
  return payload;
}
